import type { WakeLoopDaemonTaskResultPayload } from "@wakeloop/schemas/types";

export type OpenClawGatewayVisibility = NonNullable<
  WakeLoopDaemonTaskResultPayload["openClawGatewayVisibility"]
>;

export function mergeOpenClawGatewayVisibility(input: {
  primary?: WakeLoopDaemonTaskResultPayload["openClawGatewayVisibility"] | null;
  fallback?:
    | WakeLoopDaemonTaskResultPayload["openClawGatewayVisibility"]
    | null;
}): WakeLoopDaemonTaskResultPayload["openClawGatewayVisibility"] | undefined {
  const source = input.primary ?? input.fallback;
  if (!source) {
    return undefined;
  }
  return {
    agentId: source.agentId,
    gatewayRestartAttempted: source.gatewayRestartAttempted,
    gatewayVisibility: source.gatewayVisibility,
  };
}
